import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/esm/createClass";
import _defineProperty from "@babel/runtime-corejs2/helpers/esm/defineProperty";

/* tslint:disable:no-any */
import { SessionLoginListenerNativeStrategy } from './SessionLoginListenerNativeStrategy';
import { SessionLoginListenerPollingStrategy } from './SessionLoginListenerPollingStrategy';
import { SessionManagerLoginListenerStrategy } from '../types';
export var SessionLoginListener = /*#__PURE__*/function () {
  function SessionLoginListener(config) {
    _classCallCheck(this, SessionLoginListener);

    _defineProperty(this, "strategy", void 0);

    if (!config.isNativeAppDevice) {
      return;
    }

    switch (config.strategy) {
      case SessionManagerLoginListenerStrategy.Native:
        this.strategy = new SessionLoginListenerNativeStrategy(config);
        break;

      case SessionManagerLoginListenerStrategy.Polling:
        this.strategy = new SessionLoginListenerPollingStrategy(config);
        break;
    }
  }

  _createClass(SessionLoginListener, [{
    key: "start",
    value: function () {
      var _start = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this$strategy;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", (_this$strategy = this.strategy) === null || _this$strategy === void 0 ? void 0 : _this$strategy.start());

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function start() {
        return _start.apply(this, arguments);
      }

      return start;
    }()
  }, {
    key: "stop",
    value: function () {
      var _stop = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this$strategy2;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", (_this$strategy2 = this.strategy) === null || _this$strategy2 === void 0 ? void 0 : _this$strategy2.stop());

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function stop() {
        return _stop.apply(this, arguments);
      }

      return stop;
    }()
  }]);

  return SessionLoginListener;
}();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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